import { createFileRoute } from '@tanstack/react-router';
import { DetalheDoExercicio } from '@/features/exercicios/componentes/DetalheDoExercicio';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Detalhe do exercício (spec 007, CA-07). */
export const Route = createFileRoute('/_autenticado/exercicios/$id')({
  ...rotaDeTela('exercicios.lista'),
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();
  return (
    <DetalheDoExercicio
      key={id}
      id={id}
      aoExcluir={() => {
        void navigate({ to: '/exercicios' });
      }}
    />
  );
}
